import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/es.uint8-array.set-from-base64.js";
import "core-js/modules/es.uint8-array.set-from-hex.js";
import "core-js/modules/es.uint8-array.to-base64.js";
import "core-js/modules/es.uint8-array.to-hex.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import axios from 'axios';
import { numberToWords } from 'pixiu-number-toolkit';
export default {
  name: 'altimeter',
  props: {
    code: {
      type: String
    },
    name: {
      type: String
    }
  },
  data: function data() {
    return {
      viewer: undefined,
      activeName: undefined,
      fileList: [],
      errorMsg: undefined,
      fileUrl: undefined,
      loading: false,
      maxFileLen: 9,
      timer: undefined
    };
  },
  methods: {
    cancel: function cancel() {
      this.close();
      this.$emit('cancel');
    },
    getStatus: function getStatus() {
      var _this = this;
      axios.post('http://127.0.0.1:38088/video=status', JSON.stringify({})).then(function (res) {
        _this.viewer = _this.$refs.viewer;
        _this.open();
      }).catch(function (err) {
        _this.errorMsg = '无法链接高拍仪, 请检查本机是否已启动高拍仪驱动';
      });
    },
    getWords: function getWords(i) {
      if (i === 9) {
        return 'Ten';
      }
      var word = numberToWords(i + 1, 'en');
      return word.substring(0, 1).toUpperCase() + word.substring(1);
    },
    batch: function batch() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var index, self, toPDF, _toPDF, toSave, d;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              toSave = function _toSave() {
                self.loading = true;
                var data3 = {
                  PdfPath: "D://\u9AD8\u62CD\u4EEA//".concat(self.code, "_").concat(self.name, ".pdf")
                };
                axios.post('http://127.0.0.1:38088/pdf=save', JSON.stringify(data3)).then(function (res) {
                  if (res.data.code === '0') {
                    self.$emit('submit', [self.base64toFile(res.data.base64, "".concat(self.code, "_").concat(self.name, ".pdf"), 'application/pdf')]);
                  }
                }).finally(function () {
                  self.loading = false;
                });
              };
              _toPDF = function _toPDF3() {
                _toPDF = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
                  var data2;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        self.loading = true;
                        data2 = {
                          ImagePath: '',
                          ImageBase64: file
                        };
                        axios.post('http://127.0.0.1:38088/pdf=addimage', JSON.stringify(data2)).then(function (res2) {
                          self.loading = false;
                          if (res2.data.code === '0') {
                            index++;
                            if (self.fileList[index]) {
                              toPDF(self.fileList[index]);
                            } else {
                              toSave();
                            }
                            // resolve('拍照成功，并加入到PDF队列中')
                          } else {
                            self.$message.warning('加入PDF队列失败');
                            // reject('加入PDF队列失败')
                          }
                        }).finally(function () {
                          self.loading = false;
                        });
                      case 1:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return _toPDF.apply(this, arguments);
              };
              toPDF = function _toPDF2(_x) {
                return _toPDF.apply(this, arguments);
              };
              _this2.loading = true;
              index = 0;
              self = _this2;
              if (process.env.VUE_APP_GAOPAIYI === 'old') {
                toPDF(_this2.fileList[index]);
              } else {
                self.loading = true;
                d = {
                  outputfilepath: "D:\\\u9AD8\u62CD\u4EEA\\".concat(self.code, "_").concat(self.name, ".pdf"),
                  //  "outputfilepath": "",                 // 输出文件保存地址。例：D://res.jpg
                  outputmaxwidth: '3000',
                  // 合成后文件最大宽度。例：3000px
                  inputimagetype: '1',
                  // 待合成文件类型：0：file；1：base64
                  outputimagetype: '1',
                  // 合成后文件类型：0：jpg；1：PDF
                  isIDCardCompose: '0',
                  // 是否是身份证：0:普通；1:是(必须是纠偏图片)
                  imagelist: self.fileList.join(',') // 待合成图片列表。例："D:\\1.jpg,D:\\2.jpg,D:\\3.jpg"
                };
                axios.post('http://127.0.0.1:38088/compose=photos', JSON.stringify(d)).then(function (res2) {
                  if (res2.data.code === '0') {
                    self.fileList = [];
                    self.$emit('submit', [self.base64toFile(res2.data.base64, "".concat(self.code, "_").concat(self.name, ".pdf"), 'application/pdf')]);
                  }
                }).finally(function () {
                  self.loading = false;
                });
              }

              // const [err] = await this.$awaitTo(Promise.all(this.fileList.map((file) => {
              //   return new Promise((resolve, reject) => {
              //     const data2 = {
              //       ImagePath: '',
              //       ImageBase64: file
              //     }
              //     axios.post('http://127.0.0.1:38088/pdf=addimage', JSON.stringify(data2)).then((res2) => {
              //       if (res2.data.code === '0') {
              //         resolve('拍照成功，并加入到PDF队列中')
              //       } else {
              //         reject('加入PDF队列失败')
              //       }
              //     })
              //   })
              // })))
              // this.loading = false
              // if (err) {
              //   return
              // }
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    submit: function submit() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.batch();
              // if (this.fileList.length > 1) {
              //   this.batch()
              // } else {
              //   this.$emit('submit', [this.base64toFile(this.fileList[0], `${this.code}.jpg`, 'image/jpeg')])
              // }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    base64toFile: function base64toFile(base64, filename, mimeType) {
      var byteCharacters = atob(base64.replace(/^data:.*?;base64,/, ''));
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      return new File([byteArray], filename, {
        type: mimeType
      });
    },
    open: function open() {
      var _this4 = this;
      clearTimeout(this.timer);
      this.viewer.src = "http://127.0.0.1:38088/video=stream&camidx=0?".concat(Math.random() * 100);
      if (process.env.VUE_APP_GAOPAIYI === 'old') {
        this.timer = setTimeout(function () {
          _this4.rotate(90);
        }, 300);
      }
    },
    close: function close() {
      var _this5 = this;
      var data = {
        camidx: '0'
      };
      axios.post('http://127.0.0.1:38088/video=close', JSON.stringify(data)).then(function () {
        _this5.viewer.src = undefined;
      });
    },
    rotate: function rotate(angle) {
      var data = {
        camidx: '0',
        rotate: String(angle)
      };
      axios.post('http://127.0.0.1:38088/video=rotate', JSON.stringify(data)).then(function (res) {});
    },
    fileReader: function fileReader(file) {
      var self = this;
      var reader = new FileReader();
      reader.onload = function () {
        self.fileUrl = reader.result;
      };
      reader.readAsDataURL(file);
    },
    remove: function remove(index) {
      if (this.loading) {
        return;
      }
      this.fileList.splice(index, 1);
    },
    autoScan: function autoScan() {
      var _this6 = this;
      var data = {
        movedetecflag: '1',
        listpath: 'D://高拍仪',
        filepath: 'auto'
      };
      axios.post('http://127.0.0.1:38088/video=movedetec', JSON.stringify(data)).then(function (res) {
        _this6.fileList.push(res.data.data);
        if (_this6.fileList.length >= _this6.maxFileLen) {
          _this6.closeScan();
        }
      });
    },
    closeScan: function closeScan() {
      var data = {
        movedetecflag: '0'
      };
      axios.post('http://127.0.0.1:38088/video=movedetec', JSON.stringify(data)).then(function () {});
    },
    scan: function scan() {
      var _this7 = this;
      var data = {
        filepath: 'base64',
        rotate: '0',
        cutpage: '0',
        camidx: '0',
        ColorMode: '0',
        quality: '3'
      };
      this.loading = true;
      axios.post('http://127.0.0.1:38088/video=grabimage', JSON.stringify(data)).then(function (res) {
        // this.base64toFile(res.data.photoBase64, 'test', 'png')
        _this7.fileList.push(res.data.photoBase64);
      }).finally(function () {
        _this7.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.fileList = [];
    this.getStatus();
  }
};